export interface LoginPolicy {
    allowPassword: boolean;
    showGoogle: boolean;
    forceGoogle: boolean;
    allowEmailCode: boolean;
}

export const PASSWORD_ONLY_POLICY: LoginPolicy = {
    allowPassword: true,
    showGoogle: false,
    forceGoogle: false,
    allowEmailCode: true,
};

function isProdHost(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }

    const host = window.location.hostname;

    return (
        host === 'archipro.co.nz' ||
        host === 'archipro.com.au' ||
        host.endsWith('.archipro.co.nz') ||
        host.endsWith('.archipro.com.au')
    );
}

export function getLoginPolicy(email: string): LoginPolicy {
    const normalizedEmail = email.trim().toLowerCase();
    const archiproDomain = '@archipro.co.nz';
    const isArchiproEmail = normalizedEmail.endsWith(archiproDomain);
    const isArchiproPlusEmail =
        isArchiproEmail &&
        normalizedEmail.slice(0, -archiproDomain.length).includes('+');

    if (isArchiproPlusEmail) {
        return PASSWORD_ONLY_POLICY;
    }

    if (!normalizedEmail.includes('@')) {
        return { ...PASSWORD_ONLY_POLICY, allowEmailCode: false };
    }

    if (isProdHost() && isArchiproEmail) {
        return {
            allowPassword: false,
            showGoogle: true,
            forceGoogle: true,
            allowEmailCode: false,
        };
    }

    return PASSWORD_ONLY_POLICY;
}

export function canShowEmailCodeLogin(options: {
    emailCodeLoginEnabled: boolean;
    flowIsLogin: boolean;
    email: string;
    publicUserType?: 'new' | 'existing';
    emailCodeLoginAvailable?: boolean;
}): boolean {
    if (!options.emailCodeLoginEnabled || !options.flowIsLogin) {
        return false;
    }

    if (options.publicUserType !== 'existing') {
        return false;
    }

    if (options.emailCodeLoginAvailable === false) {
        return false;
    }

    const policy = getLoginPolicy(options.email);

    return policy.allowEmailCode && !policy.forceGoogle;
}
